import { ConsultationAd } from './ConsultationAd';

export function ContactPage() {
  return (
    <div className="py-12 px-4">
      <div className="container mx-auto max-w-3xl">
        <div className="mb-8 text-center">
          <h1 className="text-3xl md:text-4xl font-medium text-gray-900 mb-3">
            Contact Us
          </h1>
          <p className="text-gray-600">
            Have questions or want a personalized AI readiness consultation?
            Fill out the form below and our team will be in touch within 24 hours.
          </p>
        </div>
        <ConsultationAd />
      </div>
    </div>
  );
}
